module.exports = __webpack_public_path__ + "img/Dahlberg-11.d10f2da9.jpg";